import axios from "axios";
import moment from "moment";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DataView from "../../components/dataview/DataView";
import { AxiosInstance } from "../../axios/index";

function Letstalk_View() {
  const location = useLocation();
  const email = location.state?.email;
  const id = location.state?.id;

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!email) return;

    AxiosInstance.post("/api/letstalk/view", { email, id })
      .then((res) => {
        setUser(res.data.client?.[0]);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }, [email, id]);

  if (!user) return <div>Loading...</div>;

  const fields = [
    { label: "Name", value: user.full_name },
    { label: "Email Address", value: user.email },
    { label: "Phone Number", value: user?.phone_number || "-" },
    {
      label: "User Type",
      value: user?.typeof_client === 1 ? "Individual" : "Company",
    },
    {
      label: "Reached Out On",
      value: user?.reached_out_on
        ? moment(user.reached_out_on).format("DD/MM/YYYY")
        : "-",
    },
    ...(user?.typeof_client === 0
      ? [
          {
            label: "Company Name",
            value: user.company_name || "-",
          },
          {
            label: "Website URL",
            value: user.website_url ? (
              <a href={user.website_url} target="_blank" rel="noreferrer">
                {user.website_url}
              </a>
            ) : (
              "-"
            ),
          },
        ]
      : []),
    {
      label: "Message",
      value: user?.message || "-",
      columnSize: "col-12",
    },
  ];

  return <DataView fields={fields} />;
}

export default Letstalk_View;
